import {CategoriesStore} from "@common/store/categories.store";
import {PanierStore} from "@common/store/panier.store";
import {ActivatedRoute, Router} from "@angular/router";
import {ArticleDetailDto, CategorieDto, GedFileDescription, IGedWebServiceClient} from "@resources/resources";
import {Component} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ArianeStore, ModalService, CorrespondantStore} from "@digicerba/common";

@Component({
  selector: 'article-detail',
  templateUrl: './article.detail.component.html',
  host: {'class': 'page'}
})
export class ArticleDetailComponent {

  article: ArticleDetailDto = null;
  links: Array<GedFileDescription> = new Array<GedFileDescription>();

  isLoadingLinks : boolean = false;

  selectedValue = null;
  historiquePrecedent: number = null; //Stocke l'id d'historique dans le cas où accède depuis l'historique

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService, private categoriesStore: CategoriesStore,
              private router: Router, private activatedRoute: ActivatedRoute, private panierStore: PanierStore,
              private correspondantStore: CorrespondantStore, private modalService: ModalService, private gedWebServiceClient: IGedWebServiceClient) {
  }


  ngOnInit() {
    this.article = this.activatedRoute.snapshot.data['article'];

    let queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams) {
      this.historiquePrecedent = queryParams['h'];
    }

    this.initArianne(this.article);
    this.selectedValue = 0;


    if (this.article.tagAnalyse != null && this.article.tagAnalyse.length > 0) {
      this.isLoadingLinks = true;
      this.gedWebServiceClient.searchFiles({tag: this.article.tagAnalyse}).subscribe(data => {
        console.log("load documents done. Count:" + (data != null) ? data.length : 0);
        this.links = data;
        this.isLoadingLinks = false;
      },
      _ => {
        console.error("ERROR loading links");
        this.isLoadingLinks = false;
      });

    }
  }

  private initArianne(article: ArticleDetailDto) {
      debugger;
    let categorie: CategorieDto = this.categoriesStore.getCategorieById(article.categorieId);
      let categorieLabel = categorie && categorie.libelle.fr || article.categorieId;
    let arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.CATEGORIES.categories",
        route: "/categories/liste"
      },
      {
        libelle: this.translateService.instant("ARIANNE.CATEGORIES.category", {identifiant: categorieLabel}),
        route: "/categories/categorie/" + article.categorieId
      },
      {
        libelle: this.translateService.instant("ARIANNE.CATEGORIES.article", {identifiant: article.reference}),
        route: "/categories/article/" + article.id
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ajoutPanier() {
    this.panierStore.addItem(this.article.id, this.selectedValue).subscribe(result => {
      this.openModal();
    });
  }

  isActive() {
    return this.article.quota > 0 && this.article.actif;
  }

  getArticleQuota() {
    if (!this.article.actif) {
      return 0;
    }
    return this.article.quota;
  }

  openModal() {
    let dialog = this.modalService.openConfirmDialog("MODAL.ADD_LIGNE_COMMANDE.title", "MODAL.ADD_LIGNE_COMMANDE.message",
      "MODAL.ADD_LIGNE_COMMANDE.confirm", "MODAL.ADD_LIGNE_COMMANDE.cancel");
    dialog.onDialogClose().subscribe(() => {
      this.router.navigate(['cerba/categories/categorie', this.article.categorieId]);
    });
    dialog.onDialogCancel().subscribe(() => {
      this.router.navigate(['cerba/panier']);
    });
  }

  goBack() {
    this.router.navigate(['cerba/historique', this.historiquePrecedent]);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/article-detail/article.detail.component.ts